"use strict";

var React = require('react/addons');
var $ = require('jquery');
var _ = require('underscore');
var Tether = require('lib/tether');


var Tooltip = React.createClass({
  getDefaultProps: function() {
    return {
      orientation: 'right'
    };
  },

  getInitialState: function() {
    return {
      visible: false
    };
  },

  componentDidMount: function() {
    this.initTether();
    this.bindMouseEvents();
  },

  componentDidUpdate: function() {
    this.state.tether.position();
  },

  initTether: function() {
    // if the tooltip points to the left, we need to attach the arrow on the right and vice versa
    var attachment = this.props.orientation === "left" ? "right" : "left";
    var tether = new Tether({
      element: $(this.getDOMNode()).parent()[0],
      target: this.props.tetherTo,
      attachment: 'bottom ' + attachment,
      targetAttachment: 'top center',
      offset: '20px 0',
      constraints: [
        {
          to: 'scrollParent',
          pin: true
        }
      ]
    });
    tether.enable();

    this.setState({
      tether: tether
    });
  },

  bindMouseEvents: function() {
    var onBodyClick  = _.bind(this.onBodyClick, this);
    var onClick      = _.bind(this.onClick, this);
    var onMouseEnter = _.bind(this.onMouseEnter, this);
    var onMouseLeave = _.bind(this.onMouseLeave, this);

    $('body').on('click', onBodyClick);
    $(this.props.tetherTo).on('click', onClick);
    $(this.props.tetherTo).on('mouseenter', onMouseEnter);
    $(this.props.tetherTo).on('mouseleave', onMouseLeave);

    this.setState({
      listeners: {
        onBodyClick: onBodyClick,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }
    });
  },

  onClick: function(e) {
    e.stopPropagation();
    this.setState({visible: !this.state.visible});
  },

  onBodyClick: function(e) {
    var $el = $(this.getDOMNode());
    var $target = $(e.target);

    var clickOutside = !$el.is($target) && !$el.has($target).length;

    if (this.state.visible === true && clickOutside) {
      this.setState({visible: false});
    }
  },

  onMouseEnter: function() {
    this.setState({visible: true});
  },

  onMouseLeave: function() {
    this.setState({visible: false});
  },

  componentWillUnmount: function() {
    this.destroyTether();
    this.unbindMouseEvents();
  },

  destroyTether: function() {
    this.state.tether.destroy();
  },

  unbindMouseEvents: function() {
    $('body').off('click', this.state.onBodyClick);
    $(this.props.tetherTo).off('click', this.state.onClick);
    $(this.props.tetherTo).off('mouseenter', this.state.onMouseEnter);
    $(this.props.tetherTo).off('mouseleave', this.state.onMouseLeave);
  },

  render: function() {
    var visibilityClass = this.state.visible ? "" : "react-tooltip-hidden";
    var contents = this.props.label;

    if (this.props.children) {
      contents = this.props.children;
    }

    return (
      <div className={visibilityClass}>
        <div className="react-tooltip-label">{contents}</div>
        <div className={"react-tooltip-arrow react-tooltip-arrow-" + this.props.orientation}></div>
      </div>
    );
  }
});

module.exports = Tooltip;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/tooltip/tooltip.jsx
 **/